import { privateMenu } from './privateMenu';
import {Profile} from "../../../lib/phinxapp/profiles/types";
import {MainLayout} from "../../../application/layouts";

export const privateProfile: Profile = {
  name: 'private',
  component: MainLayout,
  menu: privateMenu,
};
